import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Sidebar from './components/Sidebar/Sidebar';
import Topbar from './components/Topbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './styles/theme.css';
import Login from './pages/Auth/Login';

import Anasayfa from './pages/Anasayfa/index';
import GenelBakis from './pages/GenelBakis/index';
import Hedefler from './pages/Hedefler/Hedefler';
import HedefFormu from './pages/HedefFormu/HedefFormu';
import HedeflerKarsilastir from './pages/HedeflerKarsilastir/HedeflerKarsilastir';
import Projeler from './pages/Projeler/Projeler';
import ProjelerListe from './pages/ProjelerListe/ProjelerListe';
import Yayinlar from './pages/Yayinlar/Yayinlar';
import YayinlarListe from './pages/YayinlarListe/YayinlarListe';
import YayinlarBirimler from './pages/YayinlarBirimler/YayinlarBirimler';
import Grafikler from './pages/Grafikler/Grafikler';
import Profil from './pages/Profil/Profil';
import Ayarlar from './pages/Ayarlar/Ayarlar';
import AkademisyenDetay from './pages/AkademisyenDetay/AkademisyenDetay';
import Birimler from './pages/Birimler/Birimler';
import BirimDetay from './pages/BirimDetay/BirimDetay';
import Akademisyenler from './pages/Akademisyenler/Akademisyenler';

export const AuthContext = React.createContext(null);

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('auth_token');
      const user = localStorage.getItem('user');
      const tokenTimestamp = token ? token.split('_').pop() : null;

      if (token && user) {
        const currentTime = Date.now();
        const tokenAge = currentTime - parseInt(tokenTimestamp);
        const oneDayInMs = 24 * 60 * 60 * 1000;

        if (tokenAge > oneDayInMs) {
          logout();
        } else {
          setIsAuthenticated(true);
        }
      }
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const login = (token, user) => {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return <div className="loading">Yükleniyor...</div>;
  }

  return (
    <ThemeProvider>
      <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
        <Router>
          <Routes>
            <Route path="/giris-yap" element={!isAuthenticated ? <Login /> : <Navigate to="/" />} />
            
            <Route path="/*" element={
              isAuthenticated ? (
                <div className="app-container">
                  <Sidebar />
                  <div className="main-wrapper">
                    <Topbar />
                    <main className="main-content">
                      <Routes>
                        <Route path="/genel-bakis" element={<GenelBakis />} />
                        <Route path="/hedefler" element={<Hedefler />} />
                        <Route path="/hedefler/hedeflerim" element={<HedefFormu />} />
                        <Route path="/hedefler/karsilastir" element={<HedeflerKarsilastir />} />
                        <Route path="/hedefler/universite" element={<Hedefler />} />
                        <Route path="/projeler" element={<Projeler />} />
                        <Route path="/projeler/liste" element={<ProjelerListe />} />
                        <Route path="/yayinlar" element={<Yayinlar />} />
                        <Route path="/yayinlar/liste" element={<YayinlarListe />} />
                        <Route path="/yayinlar/birimler" element={<YayinlarBirimler />} />
                        <Route path="/grafikler" element={<Grafikler />} />
                        <Route path="/profil" element={<Profil />} />
                        <Route path="/ayarlar" element={<Ayarlar />} />
                        <Route path="/akademisyenler" element={<Akademisyenler />} />
                        <Route path="/akademisyenler/:id" element={<AkademisyenDetay />} />
                        <Route path="/birimler" element={<Birimler />} />
                        <Route path="/birimler/:id" element={<BirimDetay />} />
                        <Route path="/" element={<Anasayfa />} />
                        <Route path="*" element={<Navigate to="/" />} />
                      </Routes>
                    </main>
                  </div>
                </div>
              ) : (
                <Navigate to="/giris-yap" />
              )
            } />
          </Routes>
        </Router>
      </AuthContext.Provider>
    </ThemeProvider>
  );
};

export default App; 